import {Form} from 'antd'
import meta from './metaPm.mjs'
import Select from './SelectPm.jsx'

export const FormItemPm = props => (
    <Form.Item
        label={meta.name}
        name="pm"
        {...props}
    >
        <Select />
    </Form.Item>
)

export const FormItemPms = props => (
    <Form.Item
        label={meta.name}
        name="pms"
        {...props}
    >
        <Select multiple />
    </Form.Item>
)
